import {
    ChangeDetectorRef,
    Directive,
    HostBinding,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges
} from '@angular/core';
import { LOGIN_SUCCESSFUL, ROUTER_NAVIGATION } from '@core/state/action-types';
import { AuthService } from '@core/state/auth/auth.service';
import { ActionsSubject } from '@ngrx/store';
import { Subject, filter, takeUntil } from 'rxjs';
import { SubscriptionLike as ISubscription } from 'rxjs';

@Directive({ selector: '[ihdAuthenticatedCheck]' })
export class AuthenticatedCheckDirective implements OnInit, OnChanges, OnDestroy {
    @Input() featureId: string;

    @HostBinding('class.hidden') hide: boolean = true;

    private actionSubDestroyed$: Subject<void> = new Subject();
    private subDestroyed$: Subject<void> = new Subject();
    private subscription: ISubscription;
    private listenTo: string[];

    constructor(
        private authService: AuthService,
        private actionsSubject$: ActionsSubject,
        private cdr: ChangeDetectorRef
    ) {
        // TODO: this needs to listen to these specific actions, need to define them in action.types.ts
        this.listenTo = [
            'EVENT_PERMISSION_CHANGED',
            LOGIN_SUCCESSFUL,
            // LOGIN_SWITCH_SUCCESS,
            // LOGIN_REFRESH,
            ROUTER_NAVIGATION,
        ];
    }

    ngOnInit() {
        this.configureActionListener();
        this.authenticate();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.featureId.currentValue) {
            this.authenticate();
        }
    }

    ngOnDestroy() {
        this.subDestroyed$.next();
        this.actionSubDestroyed$.next();
        this.subscription = null;
    }

    private configureActionListener() {
        this.actionsSubject$
            .pipe(
                takeUntil(this.actionSubDestroyed$),
                filter((action) => this.listenTo.indexOf(action.type) >= 0)
            )
            .subscribe((action) => this.authenticate());
    }

    private authenticate() {
        if (this.subscription) {
            this.subDestroyed$.next();
            this.subscription = null;
        }

        this.subscription = this.authService
            .isAuthorised(this.featureId)
            .pipe(takeUntil(this.subDestroyed$))
            .subscribe((isAllowed: boolean) => {
                this.hide = !isAllowed;
                this.cdr.detectChanges();
            });
    }
}
